import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { PreviewContext } from "../hooks/usePage";
import { useAuth } from "../context/AuthContext";
import { api, errMsg } from "../lib/api";
import SiteLayout from "../components/site/SiteLayout";
import { PAGE_COMPONENTS } from "./pageRegistry";

export default function Preview() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!user) return;
    api.get(`/admin/content/page:${slug}`).then((r) => setContent(r.data.draft)).catch((e) => setError(errMsg(e)));
  }, [slug, user]);

  if (user === null) return null;
  if (user === false) return <Navigate to="/admin/login" replace />;
  const Page = PAGE_COMPONENTS[slug];
  if (error || !Page) return <p className="p-10" data-testid="preview-error">{error || "Unknown page"}</p>;
  if (!content) return <p className="p-10" aria-busy="true">Loading draft…</p>;
  const banner = (
    <div className="bg-burgundy px-4 py-2 text-center text-sm font-semibold text-white" role="status" data-testid="draft-preview-banner">
      DRAFT PREVIEW: not visible to the public. <Link to="/admin/content" className="underline">Back to editor</Link>
    </div>
  );
  return (
    <PreviewContext.Provider value={{ slug, content }}>
      <SiteLayout banner={banner}><Page /></SiteLayout>
    </PreviewContext.Provider>
  );
}
